import { ToggleButtonGroup, ToggleButton, Button } from '@mui/material'
import { FileUploader } from "react-drag-drop-files"

import config from '/providers/config.json'

const getSteps = ({apiMode,setApiMode,handleStepChange,dataSource,setDataSource,handleDataFileUpload,passData,makePasses}) => {

  return [
    {
      label: 'Select pass mode',
      content: <ChoosePassMode apiMode={apiMode} setApiMode={setApiMode} handleStepChange={handleStepChange} />
    },
    {
      label: 'Select data source',
      content: <ChooseDataSource apiMode={apiMode} dataSource={dataSource} setDataSource={setDataSource} handleStepChange={handleStepChange} handleDataFileUpload={handleDataFileUpload} passData={passData}/>
    },
    {
      label: 'Review data',
      content: <Review apiMode={apiMode} dataSource={dataSource} handleStepChange={handleStepChange} />
    },
    {
      label: 'Create Passes',
      content: <Proceed makePasses={makePasses} dataSource={dataSource} handleStepChange={handleStepChange} apiMode={apiMode} passData={passData} />
    },
  ]
} 

export default getSteps

const ChoosePassMode = ({ apiMode, setApiMode, handleStepChange }) => {
  return (
    <div className='mb-10'>
      <div className='mb-10'>
        <p>Do you wish to make a test pass or a set of live passes?</p>
        <p className='italic mb-10'>NOTE: Test passes will automaticaly expire after 48 hours.</p>

        <ToggleButtonGroup
          value={apiMode}
          exclusive
          onChange={e => setApiMode(e.target.value)}
          color="primary"
        >
          <ToggleButton value="test">Make a TEST Pass</ToggleButton>
          <ToggleButton value="live">Make LIVE Passes</ToggleButton>
        </ToggleButtonGroup>

      </div>
      <Button disabled={true} onClick={() => handleStepChange(-1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Back</Button>
      <Button variant="contained" onClick={() => handleStepChange(1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Continue</Button>
    </div>
  )
}

  const DropTargetContent = (
    <div style={{ borderRadius: 10, border: "2px dashed white", paddingLeft: 40, paddingRight: 40, paddingTop: 10, paddingBottom: 10, marginTop: 0 }}>
      <div className='flex flex-row justify-between'>
        <div>
          <div className='text-xl mb-3'>Upload a new data file</div>
          <div>Click to select file, or drag a file here</div>
          <div>["json", "csv", "xlsx"]</div>
        </div>
      </div>
    </div>
  )


const ChooseDataSource = ({ apiMode, handleStepChange, dataSource, setDataSource, handleDataFileUpload, passData }) => {

  const disabled = dataSource === "upload" && !passData

  if (apiMode === "test") return (
    <div className='mb-10'>
      <div className='mb-10'>

        <div className='mb-10'>
          <ToggleButtonGroup
            value={dataSource}
            exclusive
            onChange={e => setDataSource(e.target.value)}
            color="primary"
          >
            <ToggleButton value="sample">Use sample data</ToggleButton>
            <ToggleButton value="upload">Upload data</ToggleButton>
          </ToggleButtonGroup>
        </div>
        
        {dataSource === "upload" && <FileUploader handleChange={handleDataFileUpload} types={["json", "csv", "xlsx"]} children={DropTargetContent} dropMessageStyle={{color:"black", fontSize:50}}/>}
      </div>

      {passData && <p className='mt-10 mb-10'>Your uploaded data contains {passData.length} passes.</p>}

      {passData && apiMode === "test" && passData.length > config.maxTestPasses &&
        <p className='mb-10'>In test mode, only your first {config.maxTestPasses} will be created.</p>}


      <Button onClick={() => handleStepChange(-1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Back</Button>
      <Button variant="contained" onClick={() => handleStepChange(1)} sx={{ mt: 1, mr: 1 }} color="secondary" disabled={disabled}>Continue</Button>
    </div>
  )

  return ( // apiMode === live
    <div className='mb-10'>
      <div className='mb-10'>
        <FileUploader handleChange={handleDataFileUpload} types={["json", "csv", "xlsx"]} children={DropTargetContent} dropMessageStyle={{padding:50,marginTop:-60,borderRadius: 10, color:"black", fontSize:50}}/>
      </div>

      {!disabled && <p className='mt-10 mb-10'>Your uploaded data contains {passData.length} passes.</p>}

      <Button onClick={() => handleStepChange(-1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Back</Button>
      <Button variant="contained" onClick={() => handleStepChange(1)} sx={{ mt: 1, mr: 1 }} color="secondary" disabled={!passData}>Continue</Button>
    </div>
  )
}

const Review = ({ handleStepChange, dataSource }) => {

  if (dataSource === "sample") return (
    <div className='mb-10'>
      <div className='mb-10'>
        <p>You are using sample data. This will be used to produce your test pass.</p>
      </div>
      <Button onClick={() => handleStepChange(-1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Back</Button>
      <Button variant="contained" onClick={() => handleStepChange(1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Continue</Button>
    </div>
  )

  return (
    <div className='mb-10'>
      <div className='mb-10'>
        <p className='mb-2'>Please compare your uploaded data to our sample data.</p>
        <p className='mb-2'>Ensure that your data has been mapped to the correct fields.</p>
        <p className='mb-2'>If there are discrepancies please do not proceed as you will create incorrect passes. Download a copy of our sample data or Excel spreadsheet and check your data against that.</p>
      </div>
      <Button onClick={() => handleStepChange(-1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Back</Button>
      <Button variant="contained" onClick={() => handleStepChange(1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Continue</Button>
    </div>
  )
}

const Proceed = ({ apiMode, dataSource, passData, makePasses, handleStepChange }) => {

  const numPasses = dataSource === "sample" ? 1 : (apiMode === "live" ? passData.length : Math.min(passData.length, config.maxTestPasses))

  return (
    <div className='mb-10'>
      <div className='mb-10'>
        <p className='mb-2'>You are about to create {numPasses} {apiMode} pass{numPasses === 1 ? "" : "es"}.</p>
      </div>
      <Button onClick={() => handleStepChange(-1)} sx={{ mt: 1, mr: 1 }} color="secondary" >Back</Button>
      <Button variant="contained" onClick={makePasses} sx={{ mt: 1, mr: 1 }} color="secondary" >Continue</Button>
    </div>
  )
}